import { Box, useMediaQuery } from "@mui/material";
import CustomerDetailsList from "../CustomerDetailsList/CustomerDetailsList";
import CustomerDetailsResponsive from "../CustomerDetailsResponsive/CustomerDetailsResponsive";
import { CustomerDetailsOverViewData } from "../../constants/CustomerDetailsOverviewData";
import { customerDetailsInvoicesTableData } from "../../constants/CustomerDetailsInvoicesTableData";
import { ClaimHistoryData } from "../../constants/ClaimHistoryData";
import { CustomerDetailsInteractionHistory } from "../../constants/CustomerDetailsInteractionHistory";
import { paymentMethodCardData } from "../../constants/PaymentMethodCard";
import { customerDetailsCardData } from "../../constants/CustomerDetailsCardData";
import { personChat } from "../../constants/myTasksPersonChatData";
import { calenderData } from "../../constants/CalenderData";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { PostCustomerMetrics } from "./CustomerDetailsAction";
import { RootState } from "../../store/store";
import { getCookie, isFeatureAvailable } from "../../utils/Utility";
import { useParams } from "react-router-dom";

const CustomerDetails = () => {
  const isSmallScreen = useMediaQuery("(max-width:1200px)");
  const carrier = getCookie("carrier");
  const system = getCookie("system");
  const dispatch = useAppDispatch();
  const { customerId } = useParams();

  const { customerMetricsData } = useAppSelector(
    (state: RootState) => state.customerMetrics
  );
  const { features } = useAppSelector((state: RootState) => state.features);

  const tasksData = [
    {
      id: "67dbbac4fe566239ef3de2cb",
      timeStamp: "21 Mar 2025,12:00 am",
      taskName: "test task",
      customerName: "new test customer",
      policyNumber: "",
      description: "no test",
      priority: "high",
      status: "Open",
      dueTime: "00:00:00",
      dueDate: "2025-03-21",
      system: "INOW",
      carrier: "SIMS",
      policyId: null,
      lobCode: null,
      providerId: "101",
    },
  ];

  const staticCustomerMetricsData = {
    totalPolicies: { carrier: "", count: 2, statusCd: "", system: "" },
    activePolicies: { carrier: "", count: 2, statusCd: "", system: "" },
    cancelNoticePolicies: { carrier: "", count: 0, statusCd: "", system: "" },
    cancelledPolicies: { carrier: "", count: 0, statusCd: "", system: "" },
    renewalInprogressPolicies: {
      carrier: "",
      count: 0,
      statusCd: "",
      system: "",
    },
    nonRenewRequestedPolicies: {
      carrier: "",
      count: 0,
      statusCd: "",
      system: "",
    },
    nonPayCancelledPolicies: {
      carrier: "",
      count: 0,
      statusCd: "",
      system: "",
    },
    futureExpiredPolicies: { carrier: "", count: 0, statusCd: "", system: "" },
  };
  const data = {
    customerId: customerId,
    carrier: carrier,
    system: system,
    policiesLimit: "500",
  };
  useEffect(() => {
    dispatch(PostCustomerMetrics(data));
  }, [dispatch]);
  return (
    <Box>
      {isSmallScreen ? (
        <CustomerDetailsResponsive
          claimData={ClaimHistoryData}
          interactionHistoryData={CustomerDetailsInteractionHistory}
          overviewData={CustomerDetailsOverViewData.overviewPolicyData}
          mytasksData={tasksData}
          invoiceCards={customerDetailsInvoicesTableData.invoicesData}
          paymentMethodCardData={paymentMethodCardData}
          customerHeaderData={customerDetailsCardData}
          notesChatData={personChat}
        />
      ) : (
        <CustomerDetailsList
          customerOverViewData={CustomerDetailsOverViewData}
          customerTasksData={tasksData}
          customerInvoicesData={customerDetailsInvoicesTableData}
          claimHistoryData={ClaimHistoryData}
          interactionHistoryData={CustomerDetailsInteractionHistory}
          paymentMethodCardData={paymentMethodCardData}
          customerHeaderCardData={
            isFeatureAvailable({
              featureCodes: ["customer_details_mock_data"],
              features,
            })
              ? staticCustomerMetricsData
              : customerMetricsData
          }
          notesChatData={personChat}
        />
      )}
    </Box>
  );
};
export default CustomerDetails;
